export default "__VITE_ASSET__Cug8cxTm__"